import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: 600,
    display: 'inline',
  },
  percentage: {
    fontWeight: 600,
    display: 'inline',
  },
}));

export default useStyles;
